import { useState } from 'react';

export const useOnMount = (callback: () => void | Promise<void>): void => {
  const [isFirst, setFirst] = useState(true);

  if (isFirst) {
    void callback();
    setFirst(false);
  }
};
